import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import ModalVideo from 'react-modal-video'

import imgHome1 from '../../../assets/images/imgHome1.png'
import imgHome2 from '../../../assets/images/imgHome2.png'
import imgHome3 from '../../../assets/images/imgHome3.png'

import imgHome4 from '../../../assets/images/imgHome4.png'

import imgHome3Mobile from '../../../assets/images/imgHomeMobile.png'
import toallaBanner from '../../../assets/images/toallaBanner.png'
import logoToalla from '../../../assets/images/logoToalla.png'
import botonFlechaHome from '../../../assets/images/botonFlechaHome.png'
import ModalPlayer from '../modalPlayer/modal-player'

import './bannerSection.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'
import { LOCALE } from '../../../constants/activity-constants'

const BannerSection = props => {
  const { isMobile } = props

  const [isOpen, setOpen] = useState(false)
  const [isLoad, setIsLoad] = useState(false)

  useEffect(() => {
    setIsLoad(true)
  }, [])

  const settings = {
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 4000,
  }

  const imagenesHome = () => {
    switch (LOCALE) {
      case 'es-DO':
        return [imgHome2, imgHome4]
      default:
        return [imgHome1, imgHome2, imgHome3]
    }
  }

  // Esta lista solo aparece en mobile :

  const imagenesHomeMobile = () => {
    switch (LOCALE) {
      case 'es-DO':
        return [imgHome3Mobile, imgHome2, imgHome4]
      default:
        return [imgHome3Mobile, imgHome1, imgHome2, imgHome3]
    }
  }

  const getVideo = () => {
    switch (LOCALE) {
      case 'es-PE':
        return 'k_ARF5Bq22s'
      case 'es-CL':
        return 'xZcHnDUQPmQ'
      case 'es-EC':
        return 'HzbCz9iSV_U'
      case 'es-AR':
        return 'gir6pRTwGz4'
      case 'es-BO':
        return 'HvNy4SOIqFI'
      case 'es-PY':
        return 'hw8KYedHh3o'
      default:
        return 'By5x-TqRQEQ'
    }
  }

  return (
    <>
      {!isMobile ? (
        <div className="f-bannerSection-container">
          {isLoad && isOpen && (
            <ModalPlayer
              src={`https://www.youtube.com/watch?v=${getVideo()}`}
              setOpen={setOpen}
            />
          )}
          <button
            className="f-bannerSection-container__buttonVideo"
            onClick={() => {
              setOpen(true)
              pushEventDataLayer(
                'Interacciones - Video',
                'Cur-v',
                'Click',
                'Mira el Video'
              )
            }}
          >
            {['es-AR', 'es-PY', 'es-UY'].includes(process.env.LOCALE) ? (
              <>Mirá el video</>
            ) : (
              <>Mira el video</>
            )}
          </button>
          <div className="f-bannerSection-container__contentSlider">
            <Slider
              {...settings}
              className="f-bannerSection-container__contentSlider__slider"
            >
              {imagenesHome().map((img, index) => (
                <img src={img} key={index} alt="imagen del Home" />
              ))}
            </Slider>
          </div>
          <div className="f-bannerSection-container__info">
            <section className="f-bannerSection-container__info__content">
              <h1>LAS NUEVAS TOALLAS PARA EL DÍA CON TECNOLOGÍA</h1>
              <img
                src={logoToalla}
                alt="logo toalla nosotras"
                className="f-bannerSection-container__info__content__logoToalla"
              />
              <img
                src={toallaBanner}
                alt="nueva toalla nosotras"
                className="f-bannerSection-container__info__content__toallaBanner"
              />
              <p>
                {['es-AR', 'es-PY', 'es-UY'].includes(process.env.LOCALE) ? (
                  <>
                    ¿Querés saber cómo funcionan? ¡Explorá nuestro sitio y
                    descubrila!
                  </>
                ) : (
                  <>
                    ¿Quieres saber cómo funciona? ¡Explora nuestro sitio y
                    descúbrela!
                  </>
                )}
              </p>
              <Link to="#visual-360">
                <img
                  src={botonFlechaHome}
                  alt="boton flecha bajar"
                  className="f-bannerSection-container__info__content__botonFlecha"
                />
              </Link>
            </section>
          </div>
        </div>
      ) : (
        <div className="f-bannerSectionMobile-container">
          {isLoad && isOpen && (
            <ModalPlayer
              src={`https://www.youtube.com/watch?v=${getVideo()}`}
              setOpen={setOpen}
            />
          )}
          <Slider
            {...settings}
            className="f-bannerSectionMobile-container__slider"
          >
            {imagenesHomeMobile().map((img, index) => (
              <img src={img} key={index} alt="imagen del Home" />
            ))}
          </Slider>
          <div className="f-bannerSectionMobile-container__info">
            <button
              className="f-bannerSection-container__buttonVideo"
              onClick={() => {
                setOpen(true)
                pushEventDataLayer(
                  'Interacciones - Video',
                  'Cur-v',
                  'Click',
                  'Mira el Video'
                )
              }}
            >
              {['es-AR', 'es-PY', 'es-UY'].includes(process.env.LOCALE) ? (
                <>Mirá el video</>
              ) : (
                <>Mira el video</>
              )}
            </button>
            <p>
              {['es-AR', 'es-PY', 'es-UY'].includes(process.env.LOCALE) ? (
                <>
                  ¿Querés saber cómo funcionan?
                  <br /> ¡Explorá nuestro sitio y descubrila!
                </>
              ) : (
                <>
                  ¿Quieres saber cómo funciona?
                  <br /> ¡Explora nuestro sitio y descúbrela!
                </>
              )}
            </p>
            <Link to="#visual-360">
              <img
                src={botonFlechaHome}
                alt="boton flecha bajar"
                className="f-bannerSection-container__info__content__botonFlecha"
              />
            </Link>
          </div>
        </div>
      )}
    </>
  )
}

export default BannerSection
